import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import { LOGIN, LOGOUT } from "../types";
// import firebase from "../../config/firebase";

export const loginAction = (creds, onSuccess = () => {}) => {
    return (dispatch) => {
        dispatch(Loader(true));
        firebase
            .auth()
            .signInWithEmailAndPassword(creds.email, creds.password)
            .then((data) => {
                onSuccess();
                dispatch(reRegisterSnapshot(data.user?.uid));
                toast.success("Login successfully");
            })
            .catch((error) => {
                onSuccess();
                dispatch(Loader(false));
                console.log(error);
                // dispatch({
                //     type: "LOGIN_FAIL",
                //     uid: "",
                //     error: error,
                // });
                // dispatch({
                //     type: "LOGIN_REQUEST_END",
                // });
                toast.error("Invalid email or password. Please try again.");
            });
    };
};

export const reRegisterSnapshot = (id) => async (dispatch) => {
    firebase
        .firestore()
        .collection("users")
        .doc(id)
        .onSnapshot(async (doc) => {
            dispatch({
                type: LOGIN,
                payload: { id: doc.id, ...doc.data() },
            });
            dispatch(Loader(false));
            // dispatch({
            //     type: "LOGIN_REQUEST_END",
            // });
        });
};

export const logout = () => async (dispatch) => {
    dispatch({
        type: LOGOUT,
    });
};
const Loader = (data) => async (dispatch) => {
    dispatch({
        type: "AUTH_LOADER",
        payload: data,
    });
};
